import React from "react";
import Portal from "../../../components/shared/portal";

const ModalInPortal = ({ openModal, portalContainerClass, modal, children }) => {
  return (
    <>
      {openModal && (
        <Portal>
          <div className={portalContainerClass}>
            {children}
            {modal}
          </div>
        </Portal>
      )}
    </>
  );
};

ModalInPortal.defaultProps = {
  portalContainerClass: "fixed overflow-scroll top-0 w-full h-full"
};

export default ModalInPortal;
